require(`./src/utils/code.css`)
